import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Options",
    type: "object",
    properties: {
      ...Utils.properties,
      list: {
        label: "Options",
        type: "array",
        items: {
          type: "string",
        },
        default: [],
      },
      allowEmpty: {
        label: "Allow empty option",
        type: "boolean",
        default: false,
      },
      default: { label: "Default option", type: "string", default: "" },
    },
    required: [],
  },
];
